export const getPaginationNumber = (type, pageDetail) => {
	var pageNumber = 1;
	if (type === "start") {
		pageNumber = ((pageDetail.page - 1) * pageDetail.limit) + 1;
	} else {
		pageNumber = pageDetail.page * pageDetail.limit;
		if (pageNumber > pageDetail.total) {
			pageNumber = pageDetail.total;
		}
	}
	return pageNumber;
}


export const formatNumber = (num) => {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}